<template>
  <f7-page name="payout-recipient-setup">
    <f7-navbar :title="$t('groupFinancialSetup.payoutRecipientSetup.title')" back-link no-shadow />
    <AppLayout>
      <template #main>
        <f7-block strong inset class="mb-3">
          <p class="font-body-sm text-on-surface-variant m-0">
            {{ $t('groupFinancialSetup.payoutRecipientSetup.description') }}
          </p>
        </f7-block>

        <f7-block-title>{{ $t('groupFinancialSetup.payoutRecipientSetup.recipientType') }}</f7-block-title>
        <f7-list inset strong dividers outline media-list>
          <f7-list-item
            v-for="type in recipientTypes"
            :key="type.value"
            @click="recipientType = type.value"
            name="recipientType"
            radio
            :value="type.value"
            :checked="recipientType === type.value"
          >
            <template #media>
              <f7-icon :material="type.icon" :size="24" class="text-primary" />
            </template>
            <template #title>{{ $t(type.labelKey) }}</template>
            <template #subtitle>{{ $t(type.descKey) }}</template>
          </f7-list-item>
        </f7-list>

        <f7-block-title v-if="recipientType=== 'INDIVIDUAL'">{{ $t('groupFinancialSetup.payoutRecipientSetup.individualDetails') }}</f7-block-title>
        <f7-list inset strong dividers outline v-if="recipientType=== 'INDIVIDUAL'">
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.fullName')"
            type="text"
            name="fullName"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.fullNamePh')"
            v-model:value="form.fullName"
            required
            clear-button
          />
<f7-list-input
             ref="individualPhoneRef"
             :label="$t('groupFinancialSetup.payoutRecipientSetup.phone')"
             type="tel"
             name="phone"
             :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.phonePh')"
             v-model:value="form.phone"
           
           />
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.email')"
            type="email"
            name="email"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.emailPh')"
            v-model:value="form.email"
            required
            clear-button
          />
         
        </f7-list>

        <f7-block-title v-if="recipientType === 'ORGANIZATION'">{{ $t('groupFinancialSetup.payoutRecipientSetup.organizationDetails') }}</f7-block-title>
        <f7-list inset strong dividers media-list outline v-if="recipientType=== 'ORGANIZATION'">
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.legalName')"
            type="text"
            name="legalName"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.legalNamePh')"
            v-model:value="form.legalName"
            required
            clear-button
          />
          <f7-list-item
            :title="$t('groupFinancialSetup.payoutRecipientSetup.legalForm')"
            smart-select
            :smart-select-params="{
              openIn: isSmallScreen ? 'sheet' : 'popover',
              closeOnSelect: true,
              swipeToClose: true,
            }"
          >
            <select name="legalform" v-model="form.legalForm">
              <option value="ASSOCIATION">{{ $t('kyc.legalFormAssociation') }}</option>
              <option value="NGO">{{ $t('kyc.legalFormNgo') }}</option>
              <option value="COOPERATIVE">{{ $t('kyc.legalFormCooperative') }}</option>
              <option value="COMPANY">{{ $t('kyc.legalFormCompany') }}</option>
              <option value="SOLE_TRADER">{{ $t('kyc.legalFormSoleTrader') }}</option>
              <option value="FOUNDATION">{{ $t('kyc.legalFormFoundation') }}</option>
            </select>
          </f7-list-item>
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.registrationNumber')"
            type="text"
            name="registrationNumber"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.registrationNumberPh')"
            v-model:value="form.registrationNumber"
            required
            clear-button
          />
          <f7-list-item
            :title="$t('groupFinancialSetup.payoutRecipientSetup.registeredCountry')"
            smart-select
            :smart-select-params="smartSelectParams"
          >
            <select name="registeredCountry" v-model="form.registeredCountry">
              <optgroup
                v-for="(countryList, continentName, index) in countries"
                :label="continentName"
                :key="index"
              >
                <option
                  v-for="country in countryList"
                  :key="country.id"
                  :value="country.countryCode2"
                  :data-option-image="`https://flagcdn.com/${country.countryCode2.toLowerCase()}.svg`"
                  width="24"
                >
                  {{ country.name }}
                </option>
              </optgroup>
            </select>
          </f7-list-item>
          <f7-list-input
          name="taxIdentifier"
            :label="$t('groupFinancialSetup.payoutRecipientSetup.taxIdentifier')"
            type="text"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.taxIdentifierPh')"
            v-model:value="form.taxIdentifier"
            clear-button
          />
        
          <f7-list-input
            ref="organizationPhoneRef"
            :label="$t('groupFinancialSetup.payoutRecipientSetup.phone')"
            type="tel"
            name="phone"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.phonePh')"
            v-model:value="form.phone"
          />
            <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.email')"
            type="email"
            name="email"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.emailPh')"
            v-model:value="form.email"
            required
            clear-button
          />
        </f7-list>

        <f7-block-title>{{ $t('groupFinancialSetup.payoutRecipientSetup.payoutPolicy') }}</f7-block-title>
        <f7-list inset strong dividers outline media-list>
          <f7-list-item
            v-for="policy in approvalPolicies"
            :key="policy.value"
            name="approvalPolicy"
            radio
            :value="policy.value"
            :checked="form.approvalPolicy === policy.value"
            @click="form.approvalPolicy = policy.value"
          >
            <template #title>{{ $t(policy.labelKey) }}</template>
            <template #subtitle>{{ $t(policy.descKey) }}</template>
          </f7-list-item>
        </f7-list>

        <f7-list inset strong dividers outline>
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.dailyLimit')"
            type="number"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.dailyLimitPh')"
            v-model:value.number="form.dailyLimit"
            inputmode="decimal"
          ><template #media>{{ group.currencyCode || group.defaultCurrency }}</template></f7-list-input>
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.singleLimit')"
            type="number"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.singleLimitPh')"
            v-model:value.number="form.singleLimit"
            inputmode="decimal"
          ><template #media>{{ group.currencyCode || group.defaultCurrency }}</template></f7-list-input>
          <f7-list-input
            :label="$t('groupFinancialSetup.payoutRecipientSetup.dualThreshold')"
            type="number"
            :placeholder="$t('groupFinancialSetup.payoutRecipientSetup.dualThresholdPh')"
            v-model:value.number="form.dualThreshold"
            inputmode="decimal"
            v-if="form.approvalPolicy === 'DUAL_APPROVAL'"
          ><template #media>{{ group.currencyCode || group.defaultCurrency }}</template></f7-list-input>
        </f7-list>

        <div class="display-flex gap-2 p-4">
          <f7-button fill large raised round class="flex-1" @click="submit">
            {{ $t('groupFinancialSetup.payoutRecipientSetup.saveAndContinue') }}
            <f7-icon f7="arrow_right" slot="end" size="18" />
          </f7-button>
        </div>
      </template>
    </AppLayout>
  </f7-page>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick, reactive } from 'vue'
import { f7 } from 'framework7-vue'
import _ from 'lodash'
import AppLayout from '../components/common/AppLayout.vue'
import { useGroupsStore } from '../js/pinia-stores/group.js'
import { useKeycloakStore } from '../js/pinia-stores/keycloak.js'
import { useLocationStore } from '../js/pinia-stores/location.js'
import { useTelephone } from '../js/composables/useTelephone.js'
import { useSmallScreen } from "../js/composables/useMediaQuery.js";
import i18n from '../js/i18n.js'
const { t } = i18n.global

const props = defineProps({
  f7route: Object,
  f7router: Object,
})

const groupsStore = useGroupsStore()
const group=computed(() => groupsStore.activeGroup)
const keycloak = useKeycloakStore()
const locationStore = useLocationStore()
const router = f7.views.main.router
const isSmallScreen = useSmallScreen().matches;
const groupId = computed(() => props.f7route?.params?.groupId)
const profile = computed(() => keycloak.profile);
const submitting = ref(false)
const individualPhoneRef = ref(null)
const organizationPhoneRef = ref(null)
const individualTel = useTelephone(individualPhoneRef)
const organizationTel = useTelephone(organizationPhoneRef)
const recipientType = ref('INDIVIDUAL')

const form = reactive({
  fullName: '',
  email: '',
  phone: '',
  legalName: '',
  legalForm: 'ASSOCIATION',
  registrationNumber: '',
  registeredCountry: '',
  taxIdentifier: '',
  approvalPolicy: 'SINGLE_APPROVER',
  dailyLimit: 500000,
  singleLimit: 100000,
  dualThreshold: 100000,
})

function populateFromProfile() {
  const p = profile.value
  if (!p) return
  form.fullName = p.name || p.given_name || ''
  form.email = p.email || ''
  form.phone = p.username || p.phoneNumber || p.upn || p.preferred_username || ''
  form.registeredCountry = p.countryCode || ''
}

function activeTelRef() {
  return recipientType.value === 'INDIVIDUAL' ? individualPhoneRef : organizationPhoneRef
}

function activeTel() {
  return recipientType.value === 'INDIVIDUAL' ? individualTel : organizationTel
}

function waitFor(predicate, timeoutMs = 3000, intervalMs = 100) {
  return new Promise((resolve) => {
    const startedAt = Date.now()
    const tick = () => {
      let value
      try {
        value = predicate()
      } catch {
        value = null
      }
      if (value) return resolve(value)
      if (Date.now() - startedAt >= timeoutMs) return resolve(null)
      setTimeout(tick, intervalMs)
    }
    tick()
  })
}

// intl-tel-input only formats what it is handed interactively, so push the
// prefilled profile number into the active instance (and re-fire input so the
// bound value stays in sync) once the field behind v-if has mounted.
async function prefillPhone() {
  if (!form.phone) return
  const input = await waitFor(() => {
    const el = activeTelRef().value
    const root = el?.$el || el
    const found = root?.querySelector?.('input') || null
    return found && activeTel().instance?.() ? found : null
  })
  if (!input) return
  const iti = activeTel().instance()
  if (typeof iti?.setNumber === 'function') {
    try {
      iti.setNumber(form.phone)
    } catch {
      /* not a dialable number (e.g. username) */
    }
  }
  try {
    input.dispatchEvent(new Event('input', { bubbles: true }))
  } catch {
    /* input may be detached */
  }
}

// Initial population
populateFromProfile()

// Watch for profile changes (async load)
watch(profile, (newProfile) => {
  if (newProfile) {
    populateFromProfile()
    prefillPhone()
  }
}, { deep: true })

// The phone fields sit behind v-if: (re)prefill whichever becomes active.
watch(recipientType, () => {
  nextTick(() => prefillPhone())
})

const recipientTypes = [
  {
    value: 'INDIVIDUAL',
    icon: 'person',
    labelKey: 'groupFinancialSetup.payoutRecipientSetup.typeIndividual',
    descKey: 'groupFinancialSetup.payoutRecipientSetup.typeIndividualDesc',
  },
  {
    value: 'ORGANIZATION',
    icon: 'business',
    labelKey: 'groupFinancialSetup.payoutRecipientSetup.typeOrganization',
    descKey: 'groupFinancialSetup.payoutRecipientSetup.typeOrganizationDesc',
  },
]

const approvalPolicies = [
  {
    value: 'SINGLE_APPROVER',
    labelKey: 'groupFinancialSetup.payoutRecipientSetup.policySingle',
    descKey: 'groupFinancialSetup.payoutRecipientSetup.policySingleDesc',
  },
  {
    value: 'DUAL_APPROVAL',
    labelKey: 'groupFinancialSetup.payoutRecipientSetup.policyDual',
    descKey: 'groupFinancialSetup.payoutRecipientSetup.policyDualDesc',
  },
]

const country = computed(() => locationStore.country)
const countries = computed(() => {
  return Array.isArray(country.value)
    ? _.groupBy(country.value, 'continentName')
    : {}
})

const groupCountry = computed(() => {
  if (!form.registeredCountry) return null
  const countryList = locationStore.country || []
  return countryList.find((c) => c.countryCode2 === form.registeredCountry)
})

const smartSelectParams = computed(() => ({
  openIn: isSmallScreen.value ? 'sheet' : 'popup',
  searchbar: true,
  closeOnSelect: true,
  swipeToClose: true,
  searchbarPlaceholder: t('common.search'),
}))

watch(
  () => locationStore.country,
  (countries) => {
    if (countries?.length && !form.registeredCountry && profile.value?.countryCode) {
      const match = countries.find((c) => c.countryCode2 === profile.value.countryCode)
      if (match) form.registeredCountry = match.countryCode2
    }
  },
  { immediate: true },
)

onMounted(() => {
  populateFromProfile()
  prefillPhone()
})

async function submit() {
  if (submitting.value) return
  submitting.value = true
  f7.preloader.show()

  try {
    const payload = {
      beneficiaryType: recipientType.value,
      approvalPolicy: form.approvalPolicy,
      dailyPayoutLimit: form.dailyLimit,
      singlePayoutLimit: form.singleLimit,
      dualApprovalThreshold: form.dualThreshold,
      requireMfaForHighValue: true,
      requesterCannotApprove: form.approvalPolicy === 'DUAL_APPROVAL',
      dualPayoutApproval: form.approvalPolicy === 'DUAL_APPROVAL',
    }

    if (recipientType.value === 'INDIVIDUAL') {
      payload.ownershipType = 'INDIVIDUAL'
      payload.displayName = form.fullName
      payload.legalCountry = profile.value?.countryCode || 'CI'
    } else {
      payload.ownershipType = 'COMPANY'
      payload.displayName = form.legalName
      payload.legalOrganizationName = form.legalName
      payload.registrationNumber = form.registrationNumber
      payload.registeredCountry = form.registeredCountry
      payload.taxIdentifier = form.taxIdentifier
      payload.legalCountry = form.registeredCountry
    }

    await groupsStore.setupPayoutConfiguration(groupId.value, payload)
    f7.preloader.hide()
    f7.toast.show({ text: t('groupFinancialSetup.payoutRecipientSetup.saved'), closeTimeout: 1500 })
    router.navigate(`/kyc/${recipientType.value === 'ORGANIZATION' ? 'organization' : 'individual'}/${groupId.value}`)
  } catch (e) {
    f7.preloader.hide()
    f7.dialog.alert(e?.response?.data?.message || t('groupFinancialSetup.payoutRecipientSetup.saveFailed'))
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.kyc-intro {
  font-size: 13px;
  color: var(--f7-on-surface-variant, #8e8e93);
  margin: 0 0 12px;
  line-height: 1.6;
}
</style>